import React, { useEffect, useRef } from "react";
import axios from "axios";
import ZoomMtgEmbedded from "@zoom/meetingsdk/embedded";

type ZoomMeetingProps = {
  meetingNumber: string;
  meetingPassword: string;
  userName: string;
  role?: number;
};
const ZoomMeeting: React.FC<ZoomMeetingProps> = ({
  meetingNumber,
  meetingPassword,
  userName,
  role = 0,
}) => {
  const client = ZoomMtgEmbedded.createClient();
  const meetingRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    getSignature();
  }, [meetingNumber, meetingPassword, userName, role]);

  const getSignature = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/zoom/signature`,
        {
          meetingNumber,
          role,
        }
      );

      if (res.data?.signature) {
      
        startMeeting(res.data.signature);
      } else {
        console.error("❌ No signature returned:", res.data);
      }
    } catch (error) {
      console.error("⚠️ Error fetching signature", error);
    }
  };

  const startMeeting = async (signature: string) => {
    if (!meetingRef.current) return;

    try {
      await client.init({
        zoomAppRoot: meetingRef.current,
        language: "en-US",
        patchJsMedia: true,
        leaveOnPageUnload: true,
      });

      await client.join({
        signature,
        sdkKey: process.env.REACT_APP_ZOOM_SDK_KEY || "",
        meetingNumber,
        password: meetingPassword,
        userName,
      });

     
    } catch (error) {
      console.error("⚠️ Error joining meeting", error);
    }
  };

  return (
    <div>
      {/* <button
        onClick={()=>startMeeting("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZGtLZXkiOiJwbTlKZUVQU1RYYUdyOUxucTJPOWRBIiwiYXBwS2V5IjoicG05SmVFUFNUWGFHcjlMbnEyTzlkQSIsIm1uIjoiOTQ3OTU5NjEwMDEiLCJyb2xlIjowLCJpYXQiOjE3NTc5MzA0MzksImV4cCI6MTc1NzkzNzYzOSwidG9rZW5FeHAiOjE3NTc5Mzc2Mzl9.bObAMm4651K2yhq1Q1CFDLZzKSI8pWJfRZi7K6x8cnM")}
        className="px-4 py-2 bg-blue-600 text-white rounded"
      >
        Join Meeting
      </button> */}    
      <div
        id="meetingSDKElement"
        ref={meetingRef}
        style={{ width: "50%", height: "50%", marginTop: "20px" }}
      ></div>
    </div>
  );
};

export default ZoomMeeting;
